import type { MouseEvent } from "react";
import clsx from "clsx";
import { AUDIT_TYPE_LABELS, type AuditType } from "@/services/api/guardiansv2/types";

export interface AuditTypeBadgeProps {
  auditType: AuditType;
  className?: string;
  /** When set, badge is a link-style control (use stopPropagation in handler for nested cards). */
  onClick?: (event: MouseEvent<HTMLButtonElement>) => void;
}

const baseClass =
  "inline-flex rounded-md px-1.5 py-0.5 text-[10px] font-medium uppercase tracking-wide";

/** Slate pill for audit subject kind; optionally opens the audited entity. */
export function AuditTypeBadge({ auditType, className = "", onClick }: AuditTypeBadgeProps) {
  const label = AUDIT_TYPE_LABELS[auditType] ?? auditType;
  const styles = clsx(
    baseClass,
    onClick
      ? "cursor-pointer bg-slate-700/60 text-indigo-200 hover:bg-slate-600/80 hover:text-indigo-100"
      : "bg-slate-700/60 text-slate-300",
    className
  );

  if (onClick) {
    return (
      <button
        type="button"
        onClick={onClick}
        className={styles}
        data-testid={`audit-type-badge-${auditType}`}
        title={`Open ${label}`}
      >
        {label}
      </button>
    );
  }

  return (
    <span className={styles} data-testid={`audit-type-badge-${auditType}`}>
      {label}
    </span>
  );
}
